import styled from "styled-components";
import { Meta } from "@sablier/v2-components/organisms";
import { Page } from "~/client/components";
import { pages } from "~/client/constants";
import Grid from "./Grid";
import Top from "./Top";

const Container = styled.div`
  ${(props) => props.theme.styles.contained}
  & {
    width: 100%;
  }
`;

interface Props {
  isGroup: boolean;
}
function Gallery({ isGroup = false }: Props) {
  return (
    <Page>
      <Meta.Head
        title={isGroup ? pages.galleryGroup.title : pages.gallery.title}
      />
      <Container>
        <Top isGroup={isGroup} />
        <Grid isGroup={isGroup} />
      </Container>
    </Page>
  );
}

export default Gallery;
